/* eslint-disable import/no-cycle */
import React from 'react';
import { GetStaticProps } from 'next';
import WithPage from '../HOC/Page/WithPage';
import PageNotFoundScreen from '../Screens/PageNotFound';
import MainLayout from '../layout/MainLayout';
import { getSiteData } from '../models/Contentful';
import type { Page } from '../models/Contentful/types';
import { DefaultPage, IStaticPageProps } from '../models/Contentful/types';
import { LayoutPage } from '../types/page';

const PageNotFound: LayoutPage<IStaticPageProps<DefaultPage>> = () => {
  return (
    <div>
      <div>
        <main>
          <PageNotFoundScreen />
        </main>
      </div>
    </div>
  );
};

export default WithPage(PageNotFound);

PageNotFound.getLayout = function getLayout(
  page: React.ReactElement,
  props: IStaticPageProps<DefaultPage>,
) {
  return <MainLayout {...props}>{page}</MainLayout>;
};

export const getStaticProps: GetStaticProps<IStaticPageProps<DefaultPage>> = async () => {
  const siteData = await getSiteData();

  return { props: { site: siteData.site, page: {} as Page & DefaultPage } };
};
